module.exports = __webpack_public_path__ + "img/digi-main.e561f717.svg";